module.exports = __webpack_public_path__ + "img/vietnam.1a4b67f4.png";